var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCar({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.75 16C7.44035 16 8 15.4403 8 14.75C8 14.0596 7.44035 13.5 6.75 13.5C6.05965 13.5 5.5 14.0596 5.5 14.75C5.5 15.4403 6.05965 16 6.75 16Z",
    fill: "#FF8F01"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.25 16C17.9403 16 18.5 15.4403 18.5 14.75C18.5 14.0596 17.9403 13.5 17.25 13.5C16.5596 13.5 16 14.0596 16 14.75C16 15.4403 16.5596 16 17.25 16Z",
    fill: "#FF8F01"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.5 18.5C2.67158 18.5 2 17.8285 2 17V12.3548C2 11.2181 2.64243 10.179 3.6593 9.6711L4.00027 9.50075L5.15525 4.54597C5.3663 3.64058 6.17335 3 7.103 3H16.9472C17.8838 3 18.695 3.64999 18.8991 4.56408L20.0016 9.50075L20.3417 9.6708C21.358 10.179 22 11.2177 22 12.354V17C22 17.8285 21.3285 18.5 20.5 18.5H19.5016V19C19.5016 20.1046 18.6054 21 17.5008 21C16.3962 21 15.5 20.1046 15.5 19V18.5H8.5V19.0002C8.5 20.1047 7.60465 21 6.50015 21C5.39565 21 4.50027 20.1047 4.50027 19.0002V18.5H3.5Z",
    stroke: "#FF8F01",
    strokeWidth: 1.125,
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7 11H17L16.174 7.28305C16.0723 6.82555 15.6666 6.5 15.1979 6.5H8.80215C8.33345 6.5 7.92765 6.82555 7.826 7.28305L7 11Z",
    stroke: "#FF8F01",
    strokeWidth: 1.125,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCar);
export default __webpack_public_path__ + "static/media/car.e0f8f5e14f8a5eacd4ed1b957ab1563b.svg";
export { ForwardRef as ReactComponent };